import { render, staticRenderFns } from "./SpecialDisabledCard.vue?vue&type=template&id=688a596e&"
import script from "./SpecialDisabledCard.vue?vue&type=script&lang=ts&"
export * from "./SpecialDisabledCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports